function testIfPolicyAppliesToProduct (product, policy) {
  if (policy.productCode) {
    return product.productCode === policy.productCode
  }

  return (
    (!policy.productClassificationId ||
      policy.productClassificationId == product.classificationId) &&
    (!policy.productCategory || policy.productCategory == product.category) &&
    (!policy.productTypeCode || policy.productTypeCode == product.typeCode) &&
    (!policy.productBrochureCode ||
      policy.productBrochureCode == product.brochureCode)
  )
}

function commissionFromPromotion ({priceBreakdown, product}) {
  return priceBreakdown.discounts.promotions.applied
    .filter(promotion => {
      return (
        (promotion.commissionAmount === 0 || promotion.commissionAmount > 0) &&
        promotion.products.find(p => p.productCode == product.productCode)
      )
    })
    .reduce((result, promotion) => {
      if (!result || result.amount > promotion.commissionAmount) {
        return {amount: promotion.commissionAmount}
      }
      return result
    }, null)
}

function isAirPolicy (policy) {
  return policy.productTypeCode == 'NA'
}

function calculateCommissionFromPolicyAmount (policy, useAirAmount) {
  if (useAirAmount && !isAirPolicy(policy)) {
    return policy.airAmount || policy.amount
  } else {
    return policy.amount
  }
}

function chooseLowestCommission ({
  commissionFromPromotion,
  commissionFromPolicy,
  useAirAmount,
}) {
  if (!commissionFromPolicy && !commissionFromPromotion) {
    return
  } else if (!commissionFromPolicy) {
    return commissionFromPromotion
  } else {
    let commissionFromPolicyAmount = calculateCommissionFromPolicyAmount(
      commissionFromPolicy,
      useAirAmount
    )

    if (
      commissionFromPromotion &&
      commissionFromPromotion.amount < commissionFromPolicyAmount
    ) {
      return commissionFromPromotion
    } else {
      return {
        amount: commissionFromPolicyAmount,
        supplementAmount: commissionFromPolicy.supplementAmount,
        surchargeCommissions: commissionFromPolicy.surchargeCommissions,
      }
    }
  }
}

function calculateTax (commission, productCode, policyCommissionAmount) {
  const taxRate = commission.tax && commission.tax.rate
  var tax = 0
  if (taxRate && taxRate.grossOrNett == 'nett') {
    const productPercentageWhereTaxApplies =
      commission.tax.productPercentages[productCode] || 0
    const amountWhereTaxApplies = policyCommissionAmount * productPercentageWhereTaxApplies / 100

    tax = amountWhereTaxApplies -
    amountWhereTaxApplies / (1 + commission.tax.rate.percentage / 100)
  }
  return tax
}

function calculateProductCommission ({product, priceBreakdown, commission, sortedPolicies}) {
  let policyCommissionAmount = 0

  const matchedPolicy = chooseLowestCommission({
    commissionFromPromotion: commissionFromPromotion({priceBreakdown, product}),
    commissionFromPolicy: sortedPolicies.find(
      testIfPolicyAppliesToProduct.bind(null, product)
    ),
    useAirAmount: !!priceBreakdown.flights,
  })

  if (matchedPolicy) {
    if (product.surchargeTypeId) {
      (matchedPolicy.surchargeCommissions || []).forEach(sc => {
        if (sc.surchargeTypeId == product.surchargeTypeId) {
          var surchargeCommissionAmount = product.totalPrice * sc.amount / 100
          policyCommissionAmount += surchargeCommissionAmount
        }
      })
    } else if (product.isSupplementProduct) {
      policyCommissionAmount = matchedPolicy.supplementAmount * product.totalPrice / 100
    } else {
      policyCommissionAmount = matchedPolicy.amount * product.totalPrice / 100
    }
    policyCommissionAmount -= calculateTax (commission, product.productCode, policyCommissionAmount)
  }
  return policyCommissionAmount
}

export default calculateProductCommission
